import { Component, computed, effect, Input, OnDestroy, OnInit, signal } from '@angular/core';

// Models
import { Template } from '../crm-shared-configuration/models/template.model';
import { TemplateUpdate } from '../crm-shared-configuration/models/templateUpdate.model';
import { FieldData } from '../crm-shared-configuration/models/fieldData.model';

// Services
import { AppMainService } from 'src/app/app-main.service';
import { CrmSharedConfigurationService } from '../crm-shared-configuration/services/crm-shared-configuration.service';

// Constants and Enums
import { Answer, Messages, Severity } from 'src/app/configurations/crm/constants/constants';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TerritoryConfig } from 'src/app/configurations/fsm/territory/models/territory-config.model';
import { TerritoryService } from 'src/app/configurations/fsm/territory/services/territory.service';
import { MessageService } from 'primeng/api';
import { AccountModuleId, CaseModuleId, LeadModuleId, OpportunityModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { CrmSettingsService } from 'src/app/modules/shared/services/crm-settings.service';

@Component({
    selector: 'app-crm-shared-template',
    templateUrl: './crm-shared-template.component.html',
    styleUrls: ['./crm-shared-template.component.scss'],
})
export class CrmSharedTemplateComponent implements OnInit, OnDestroy {
    @Input() moduleId: number;
    isEnabledParentChildTemplate :boolean=false

    answertypeConstants = Answer;

    templates: Template[] = [];
    selectedTemplate: Template;
    storedTemplate: Template;
    noDataTemplate: string = 'Loading Templates...';
    displayUpdateTemplate: boolean = false;
    updatedFields: FieldData[] = [];
    templateHeader: string = '';

    templateAvailableSections = [];
    templateSelectedSections = [];

    availableCaseLabels = [];
    selectedCaseLabels = [];

    selectedSectionHeader = [];;
    row1CheckBoxStateValue = false;

    accountEmail = [];
    accountPhone = [];
    accountSocial = [];
    currrentAccountFieldConfig = [];
    emailConfigAccount;
    phoneConfigAccount;
    socialConfigAccount;

    availableAccountEmailLabels = [];
    selectedAccountEmailLabels = [];
    availableAccountPhoneLabels = [];
    selectedAccountPhoneLabels = [];
    availableAccountSocialLabels = [];
    selectedAccountSocialLabels = [];
    templatesVm = "";

    checkMaxDuplicate: boolean = false;
    checkMaxGlobeSearch: boolean = false;
    duplicateMinMsg: boolean = false;

    territoryConfig: TerritoryConfig[] = [];

    /* Subject to unsubscribe */
    private ngUnsubscribe = new Subject<void>();

    constructor(
        private configService: CrmSharedConfigurationService,
        private appMainService: AppMainService,
        public territoryService: TerritoryService,
        private messageService: MessageService,
        private crmSettingsService: CrmSettingsService
        ) {
    }

    ngOnInit(): void {
        this.getTemplates();
       this.isEnabledParentChildTemplate= this.crmSettingsService.showEnableDisableColumnSetting
    }

    // Template Operations
    getTemplates(): void {
        this.noDataTemplate = 'Loading Templates...';
        this.configService.getTemplates(this.moduleId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(templates => {
                this.templates = templates || [];
                this.noDataTemplate = this.templates.length ? '' : 'No template found.';
            }, () => {
                this.noDataTemplate = 'No template found.';
            });
    }

    getTemplateDetails(templateId: number): void {
        this.appMainService.isShowSpinner('getTemplateDetails');
        this.configService.getTemplateDetails(this.moduleId, templateId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: template => {
                    this.appMainService.isHideSpinner('getTemplateDetails');
                    if (this.moduleId == AccountModuleId){
                        this.getTerritoryConfig();
                    }
                    this.templateHeader = this.getTemplateHeader(this.moduleId);
                    template?.sections.map(section=>{
                        section.fields.map(field=>{
                            field.showChildren = false;
                        })
                    });
                    this.selectedTemplate = template;

                    this.storedTemplate = JSON.parse(JSON.stringify(template));
                    this.updatedFields = [];
                    this.displayUpdateTemplate = true;
                },
                error: (error)=>{
                    this.appMainService.isHideSpinner('getTemplateDetails');
                }
            });
    }

    getTemplateHeader(moduleId: number): string {
        let header: string = '';
        if (moduleId === AccountModuleId){
            header = 'Account Template';
        }
        else if (moduleId === LeadModuleId){
            header = 'Lead Template';
        }
        else if (moduleId === OpportunityModuleId){
            header = 'Opportunity Template'
        } else if (moduleId === CaseModuleId){
            header = 'Case Template'
        }
        return header;
    }

    getTerritoryConfig(): void {
        this.appMainService.isShowSpinner('getTerritoryConfig');
        this.territoryService.getTerritoryConfig()
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe({
                    next: (response) => {
                        this.territoryConfig = response;
                        this.appMainService.isHideSpinner('getTerritoryConfig');
                    },
                    error: ((error) => {
                        this.appMainService.isHideSpinner('getTerritoryConfig');
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message ? error?.error?.Message : 'Territory config is not loaded..' });
                    }),
                    complete: (() => {
                    })
                });

      }

    showUpdateTemplateModal(template: Template) {
        this.getTemplateDetails(template.id);
    }

    updateTemplateFields(): void {
        const payload: TemplateUpdate = this.getFieldsUpdatePayload();

        this.appMainService.isShowSpinner('updateTemplateFields');
        this.configService.updateTemplate(payload)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
                this.displayUpdateTemplate = false;
                this.configService.openToast(Severity.Success, Messages.Template_Updated_Success);
                this.appMainService.isHideSpinner('updateTemplateFields')
            }, (err) => {
                this.displayUpdateTemplate = false;
                const message: string = this.configService.getErrorMessage(err, 'TEMPLATE_UPDATE');
                this.configService.openToast(Severity.Error, message);
                this.appMainService.isHideSpinner('updateTemplateFields');
            });
    }

    setUpdatedFields(event, sectionIndex: number, fieldIndex: number, childFieldIndex: number ,enabledInForm?:string): void {
        let selectedField: any;
        let storedField: any;
        let foundIndex: number

        if (childFieldIndex >= 0) {
            selectedField = 
                this.selectedTemplate.sections[sectionIndex].fields[fieldIndex].childFields[childFieldIndex]
               
            if (event.checked === false) {
                selectedField.enabledColumnSetting = false;
            }

            storedField = 
                this.storedTemplate.sections[sectionIndex].fields[fieldIndex].childFields[childFieldIndex]
            foundIndex = this.updatedFields.findIndex(field => field.id === storedField.id);
        } else {
            selectedField = 
                this.selectedTemplate.sections[sectionIndex].fields[fieldIndex]

            if (event.checked === false && enabledInForm === 'enabledInForm') {
                selectedField.enabledColumnSetting = false;
                selectedField.enabledInChildAccount=false;
                selectedField.isUnique=false;
            }

            storedField = 
                this.storedTemplate.sections[sectionIndex].fields[fieldIndex]
            foundIndex = this.updatedFields.findIndex(field => field.id === selectedField.id);
        }

        if (selectedField.labelName !== storedField.labelName ||
            selectedField.enabledInForm !== storedField.enabledInForm ||
            selectedField.enabledColumnSetting !== storedField.enabledColumnSetting ||selectedField.enabledInChildAccount !== storedField.enabledInChildAccount ||selectedField.isUnique !== storedField.isUnique) {
            if (foundIndex === -1) {
                this.updatedFields.push(selectedField);
            } else {
                this.updatedFields[foundIndex] = selectedField;
            }
        } else {
            if (foundIndex > -1) {
                this.updatedFields.splice(foundIndex, 1);
            }
        }
    }

    getFieldsUpdatePayload(): TemplateUpdate {
        const fields = [];

        for (const field of this.updatedFields) {
            fields.push({
                id: field.id,
                labelName: field.labelName,
                enabledInForm: field.enabledInForm,
                enabledColumnSetting: field.enabledColumnSetting,
                enabledInChildAccount: field.enabledInChildAccount,
                isUnique: field.isUnique,
            });

            for (const childField of field.childFields) {
                fields.push({
                    id: childField.id,
                    labelName: childField.labelName,
                    enabledInForm: childField.enabledInForm,
                    enabledColumnSetting: childField.enabledColumnSetting,
                    enabledInChildAccount: childField.enabledInChildAccount,
                    isUnique: childField.isUnique,
                });
            }
        }

        const payload: TemplateUpdate = {
            moduleId: this.moduleId,
            templateId: this.selectedTemplate.id,
            fields
        };

        return payload;
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
